import React from "react";
import AddProject from "./AddProject";
export const AddProjectIndex: React.FC = () => {

    return (
        <AddProject/>
    )
} 